import { IYouKassaPaymentFormsApi } from "integrations/youkassa/payments";
import { useLayoutEffect } from "react";

import styles from './paymentForm.module.scss';

export interface SubscriptionPaymentFormProps {
	formsApi: IYouKassaPaymentFormsApi;
	confirmationToken: string;
}

export const SubscriptionPaymentForm = (props: SubscriptionPaymentFormProps) => {
	const elementId = 'payment-form';

	useLayoutEffect(() => { props.formsApi.createPaymentForm(elementId, props.confirmationToken) }, []);

	return <div id={elementId} className={styles.form}></div>;
}